export const GlobalStyles = {
  // Layout
  pageContainer: `min-h-screen bg-gray-50 dark:bg-gray-900 transition-all duration-300`,
  contentContainer: `w-full max-w-full p-5`,

  // Cards
  card: `bg-white dark:bg-gray-800 rounded-lg border border-gray-100 dark:border-gray-700 p-6 transition-all duration-300`,
  cardHover: `bg-white dark:bg-gray-800 rounded-lg border border-gray-100 dark:border-gray-700 p-6 transition-all duration-300 hover:shadow-md hover:-translate-y-0.5`,

  // Buttons
  button: `flex items-center justify-center font-medium rounded-lg transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-primary/50`,

  buttonPrimary: `bg-primary text-white hover:bg-primary/90 active:scale-95`,
  buttonOutline: `border border-primary text-primary hover:bg-primary/5 dark:border-primary dark:text-primary dark:hover:bg-primary/10`,
  buttonGhost: `text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-gray-900 dark:hover:text-white`,
  buttonDanger: `bg-red-500 text-white hover:bg-red-600 active:scale-95`,
  buttonSuccess: `bg-green-500 text-white hover:bg-green-600 active:scale-95`,
  buttonError: `bg-red-500 text-white hover:bg-red-600 active:scale-95`,

  buttonSmall: "px-3 py-1.5 text-sm",
  buttonMedium: "px-4 py-2.5 text-base",
  buttonLarge: "px-6 py-3 text-lg",

  // Inputs
  input: `w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-300 text-gray-900 dark:text-white placeholder:text-gray-500 dark:placeholder:text-gray-400`,
  inputError: "border-red-500 focus:ring-red-500",
  inputLabel: `font-medium text-sm mb-2 text-gray-700 dark:text-gray-300`,

  // Text
  heading1: "text-3xl font-bold text-gray-900 dark:text-white",
  heading2: "text-2xl font-bold text-gray-900 dark:text-white",
  heading3: "text-xl font-semibold text-gray-900 dark:text-white",
  bodyText: "text-gray-600 dark:text-gray-400",
  smallText: "text-sm text-gray-500 dark:text-gray-400",

  // Badges
  badge: `rounded-full inline-flex items-center justify-center px-2.5 py-0.5 text-xs font-medium`,
  badgeSuccess:
    "bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-300",
  badgeWarning:
    "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/20 dark:text-yellow-300",
  badgeError: "bg-red-100 text-red-800 dark:bg-red-900/20 dark:text-red-300",
  badgeInfo: "bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-300",
  badgePrimary: "bg-primary/10 text-primary dark:bg-primary/20",

  // Tables
  table: `w-full border-collapse`,
  tableHeader: `bg-gray-50 dark:bg-gray-800/50 font-semibold text-gray-700 dark:text-gray-300`,
  tableRow:
    "border-b border-gray-100 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors",
  tableCell: "px-6 py-4",

  // Alerts
  alert: `rounded-lg p-4 flex items-start gap-3`,
  alertInfo:
    "bg-blue-50 text-blue-800 dark:bg-blue-900/20 dark:text-blue-300 border border-blue-200 dark:border-blue-800",
  alertSuccess:
    "bg-green-50 text-green-800 dark:bg-green-900/20 dark:text-green-300 border border-green-200 dark:border-green-800",
  alertWarning:
    "bg-yellow-50 text-yellow-800 dark:bg-yellow-900/20 dark:text-yellow-300 border border-yellow-200 dark:border-yellow-800",
  alertError:
    "bg-red-50 text-red-800 dark:bg-red-900/20 dark:text-red-300 border border-red-200 dark:border-red-800",

  // Loaders
  spinner:
    "animate-spin rounded-full border-3 border-t-transparent border-primary",

  // Grid
  gridCols1: "grid grid-cols-1",
  gridCols2: "grid grid-cols-1 md:grid-cols-2",
  gridCols3: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3",
  gridCols4: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4",

  // Spacing
  sectionSpacing: "mb-8",
  cardSpacing: "space-y-6",

  // Misc
  iconButton:
    "p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors",

  // Chat specific styles
  chatMessageOwn: "bg-primary text-white rounded-2xl rounded-br-none",
  chatMessageOther:
    "bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-white rounded-2xl rounded-bl-none",
  chatBubble: "px-4 py-3 max-w-[85%]",
  chatTime: "text-xs opacity-70 mt-1",
  chatAttachment:
    "mt-2 rounded-lg overflow-hidden border border-gray-200 dark:border-gray-700",

  // Modal styles
  modalBackdrop: "fixed inset-0 bg-black bg-opacity-50 z-50 transition-opacity",
  modalContainer:
    "fixed z-50 bg-white dark:bg-gray-900 shadow-2xl rounded-xl md:rounded-2xl",

  // Input styles for chat
  chatInput:
    "min-h-[44px] max-h-[120px] resize-none pr-12 border-2 focus:border-primary transition-colors rounded-xl",

  // Button styles for chat
  chatButton:
    "p-2.5 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors",
  chatSendButton:
    "p-3 rounded-full bg-primary hover:bg-primary/90 text-white transition-colors",

  // Badge styles
  badgeNotification:
    "absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center",
};
